// extracted by mini-css-extract-plugin
module.exports = {"root":"Spinner_root__1oXmL","roller":"Spinner_roller__19QbP"};